<template>
    <form novalidate class="md-layout" @submit.prevent="onSubmit">
        <md-card class="md-layout-item md-size-100 md-small-size-100">
            <md-card-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50">
                        <md-field :class="getValidationClass('oldPassword')">
                            <label for="password">{{ $t(`views.profile.passwordChange.form.oldPassword`) }}</label>
                            <md-input id="password" autocomplete="off" v-model="form.oldPassword" :disabled="form.sending"
                                      type="password" />
                            <span class="md-error" v-if="!$v.form.oldPassword.required">{{ $t('validation.required') }}</span>
                            <server-error v-else :server-errors="serverErrors" field-name="oldPassword" />
                        </md-field>
                    </div>
                </div>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50">
                        <md-field :class="getValidationClass('newPassword')">
                            <label for="newPassword">{{ $t(`views.profile.passwordChange.form.newPassword`) }}</label>
                            <md-input id="newPassword" autocomplete="off" v-model="form.newPassword" :disabled="form.sending"
                                      type="password" />
                            <span class="md-error" v-if="!$v.form.newPassword.required">{{ $t('validation.required') }}</span>
                            <span class="md-error" v-else-if="!$v.form.newPassword.minLength">{{ $t(`views.profile.passwordChange.validation.password.minLength`, {0: $v.form.newPassword.$params.minLength.min}) }}</span>
                            <server-error v-else :server-errors="serverErrors" field-name="password" />
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-50">
                        <md-field :class="getValidationClass('repeatPassword')">
                            <label for="repeatPassword">{{ $t(`views.profile.passwordChange.form.repeatPassword`) }}</label>
                            <md-input id="repeatPassword" autocomplete="off" v-model="form.repeatPassword"
                                      :disabled="form.sending" type="password" />
                            <span class="md-error" v-if="!$v.form.repeatPassword.required">{{ $t('validation.required') }}</span>
                            <span class="md-error" v-else-if="!$v.form.repeatPassword.sameAsPassword">{{ $t('validation.sameAsPassword') }}</span>
                        </md-field>
                    </div>
                </div>
            </md-card-content>

            <md-progress-bar md-mode="indeterminate" v-if="form.sending" />

            <md-card-actions>
                <md-button type="submit" class="md-primary" :disabled="form.sending">
                    {{ $t(`views.profile.passwordChange.form.submit`) }}
                </md-button>
            </md-card-actions>
        </md-card>
    </form>
</template>

<script>
    import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
    import {required, minLength, sameAs} from 'vuelidate/lib/validators';
    import ServerError from '@/components/ServerError';
    import {usersEndpoint} from '@/services/adsign-backend/endpoints';

    export default {
        name: 'PasswordChange',
        components: { ServerError },
        mixins: [serverSideValidationErrors],
        data: function() {
            return {
                title: this.$t(`views.profile.passwordChange.title`),
                form: {
                    sending: false,
                    oldPassword: null,
                    password: null,
                    repeatPassword: null
                }
            }
        },
        validations: {
            form: {
                oldPassword: {
                    required
                },
                newPassword: {
                    required,
                    minLength: minLength(8)
                },
                repeatPassword: {
                    required,
                    sameAsPassword: sameAs('newPassword')
                }
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();

                const formData = {
                    oldPassword: this.form.oldPassword,
                    password: this.form.newPassword,
                };

                if (!this.$v.$invalid) {
                    this.form.sending = true;

                    usersEndpoint.changePassword(formData)
                        .then(() => {
                            this.flash(this.$t('views.profile.passwordChange.success'), 'success');
                        })
                        .catch(this.handleServerValidationError)
                        .catch(error => {
                            const errorMessageCode = _.get(error, 'response.data.data.errorMessageCode');
                            if (errorMessageCode === 'WRONG_USER_CREDENTIALS') {
                                this.serverErrors = {
                                    oldPassword: this.$t('views.profile.passwordChange.validation.password.invalid')
                                }
                            }
                        })
                        .finally(() => this.form.sending = false);
                }
            }
        }
    }
</script>

<style scoped>

</style>
